/**
 * Converts HTML content to plain text by removing tags.
 * Uses safe, non-backtracking approach to avoid ReDoS attacks.
 */
export const convertHtmlToText = (htmlContent: string): string => {
  if (!htmlContent) return htmlContent;

  let text = htmlContent;

  // Replace <br> tags with newlines (safe - specific pattern)
  text = text.replaceAll(/<br\s?\/?>/gi, "\n");

  // Replace closing </p> tags with double newlines (safe - literal string)
  text = text.replaceAll(/<\/p>/gi, "\n\n");

  // Remove HTML tags safely without backtracking risk
  // Process character by character to avoid regex vulnerabilities
  let result = "";
  let isInsideTag = false;

  for (const char of text) {
    if (char === "<") {
      isInsideTag = true;
    } else if (char === ">") {
      isInsideTag = false;
    } else if (!isInsideTag) {
      result += char;
    }
  }

  return result.trim();
};
